import { AxiosResponse } from "axios";
import { SubledgerEndpoints } from "../../SubledgerEndpoints";

import { IValidationMessage } from "../../schemas/ISLEntryResponse";
import { ISLBatchPostBody } from "../../schemas/SLBatchPostBody";
import { config } from "../../config";
import { authPost, authPatch, authGet } from "../../services/RequestHelpers";
import { IUserProviderState } from "../../contexts/UserContext";
import { ISLBatchResponse } from "./SLBatchSchemas";

export async function saveSLBatch(
  batchPostBody: ISLBatchPostBody,
  getTokenFn: IUserProviderState["accessToken"]
): Promise<AxiosResponse<ISLBatchResponse>> {
  const saveSLBatchUrl =
    config.get("subledgerUrl") + SubledgerEndpoints.slBatchActions + SubledgerEndpoints.slBatchSave;
  const result: AxiosResponse<ISLBatchResponse> = await authPost(saveSLBatchUrl, getTokenFn, batchPostBody);
  return result;
}

export async function postSLBatch(
  batchPostBody: ISLBatchPostBody,
  getTokenFn: IUserProviderState["accessToken"]
): Promise<AxiosResponse<IValidationMessage[]>> {
  const postSLBatchUrl =
    config.get("subledgerUrl") + SubledgerEndpoints.slBatchActions + SubledgerEndpoints.slBatchPost;

  const result: AxiosResponse<IValidationMessage[]> = await authPost(postSLBatchUrl, getTokenFn, batchPostBody);
  return result;
}

export async function validateSLBatch(
  batchPostBody: ISLBatchPostBody,
  getTokenFn: IUserProviderState["accessToken"]
): Promise<AxiosResponse<IValidationMessage[]>> {
  const validateSLBatchUrl =
    config.get("subledgerUrl") + SubledgerEndpoints.slBatchActions + SubledgerEndpoints.slBatchValidate;

  const result: AxiosResponse<IValidationMessage[]> = await authPatch(validateSLBatchUrl, getTokenFn, batchPostBody);
  return result;
}

export async function getSLBatchEntry(
  slBatchRefGUID: string,
  getTokenFn: IUserProviderState["accessToken"]
): Promise<AxiosResponse<any>> {
  const getSLEntryUrl = config.get("subledgerUrl") + SubledgerEndpoints.slBatchActions + slBatchRefGUID;
  const result = await authGet(getSLEntryUrl, getTokenFn);
  return result;
}
